<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" @click:outside="$emit('close')">
      <v-alert
        dense
        outlined
        type="error"
        style="margin-bottom: 0; background-color:white !important"
      >
        <h3>Bitte Prüfen Sie Ihre Eingaben</h3>
        <br />
        <ul>
          <li v-for="error in errorList" :key="error.field">
            <strong>{{ error.field }}</strong>
            <div v-for="val in error.validations" :key="val">{{ val }}</div>
          </li>
        </ul>
        <v-container class="text-right">
          <v-btn right dark :color="$mainPeacock" @click="$emit('close')">
            OK
          </v-btn>
        </v-container>
      </v-alert>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["errorList", "dialog"],
  data() {
    return {};
  }
};
</script>
